export const iconFontAwesomeAlphabetL = (
	<i className="fa-solid fa-l"></i>
);
